import { useEffect } from "react";

// Ajouter l'id animated à un élément pour lui donner l'animation fading sur le vertical au scroll
// Ajouter l'id animated-right à un élément pour lui donner l'animation fading sur le horizontal droite au scroll
// Ajouter l'id animated-left à un élément pour lui donner l'animation fading sur le horizontal left au scroll

export const useGraphicEffects = () => {
  function callback(entries, classToAdd) {
    entries.filter((el) => {
      if (el.isIntersecting) {
        el.target.classList.add(classToAdd);
      }
    });
  }

  useEffect(() => {
    let keypoints;
    let keypointsTransitionRight;
    let keypointsTransitionLeft;
    if ("IntersectionObserver" in window) {
      const elementToTrigger = class ElementToTrigger {
        constructor(public observer: IntersectionObserver, public id?: string) {
          this.init();
        }

        init() {
          const targets = document.querySelectorAll(this.id);

          targets.forEach((li) => {
            this.observer.observe(li);
          });
        }
      };

      const options = {
        rootMargin: "0px",
        threshold: 0,
      };

      // Classic transition

      const observer = new IntersectionObserver(
        (entries) => callback(entries, "visible"),
        options
      );

      keypoints = new elementToTrigger(observer, "#animated");

      // Right transition

      const observerTransitionRight = new IntersectionObserver(
        (entries) => callback(entries, "transitionRight"),
        options
      );

      keypointsTransitionRight = new elementToTrigger(
        observerTransitionRight,
        "#animated-right"
      );

      // Left transition

      const observerTransitionLeft = new IntersectionObserver(
        (entries) => callback(entries, "transitionLeft"),
        options
      );

      keypointsTransitionLeft = new elementToTrigger(
        observerTransitionLeft,
        "#animated-left"
      );
    } else {
      const list = (window as Window).document.querySelectorAll("#animated");
      list.forEach(function (item) {
        (item as HTMLElement).style.opacity = "1";
      });
    }

    return () => {
      keypoints = null;
      keypointsTransitionLeft = null;
      keypointsTransitionRight = null;
    };
  }, []);
};
